<form
  (ngSubmit)="onSubmit()"
  [formGroup]="csAgentLoginForm"
  *ngIf="!csAgentTokenLoading"
>
  <label>
    <input
      aria-required="true"
      type="text"
      formControlName="userId"
      placeholder="{{ 'asm.loginForm.userId.label' | cxTranslate }}"
    />
    <cx-form-errors
      aria-live="assertive"
      aria-atomic="true"
      [control]="csAgentLoginForm.get('userId')"
    ></cx-form-errors>
  </label>

  <label>
    <input
      aria-required="true"
      type="password"
      placeholder="{{ 'asm.loginForm.password.label' | cxTranslate }}"
      formControlName="password"
    />
    <cx-form-errors
      aria-live="assertive"
      aria-atomic="true"
      [control]="csAgentLoginForm.get('password')"
    ></cx-form-errors>
  </label>
  <button type="submit">
    {{ 'asm.loginForm.submit' | cxTranslate }}
  </button>
</form>

<div
  *ngIf="csAgentTokenLoading"
  class="spinner"
  aria-hidden="false"
  [attr.aria-label]="'common.loading' | cxTranslate"
>
  <div></div>
  <div></div>
  <div></div>
</div>
